function isValidPrice(price: number | string): boolean {
  if (price === null || typeof price === 'undefined' || price === '') return false

  return !!Number(price) || Number(price) === 0
}

export default isValidPrice
